module.exports = __webpack_public_path__ + "images/jtautoleasef5d9e5ec1200035920f6970ad7d7d258.png";